import ProxyBase from '../../../../../../../core/proxies/ProxyBase'

export class FDIProxy extends ProxyBase {
  getFdiData(params) {
    return this.get('FDI', params)
  }
}

export default new FDIProxy('IndustryOverview/')
